import React from 'react';
import { DownloadIcon, FileTextIcon } from 'lucide-react';
import { ProcessingResult, RunAuditRecord } from '../types/borrowerChecker';
import { generateMissingLoansCSV, generateRunAuditCSV, downloadCSV, getMissingLoansFilename, getRunAuditFilename, estimateFileSize } from '../utils/csvGenerator';
interface AuditDownloadsProps {
  result: ProcessingResult;
  auditRecord: RunAuditRecord;
}
export function AuditDownloads({
  result,
  auditRecord
}: AuditDownloadsProps) {
  const missingCSV = generateMissingLoansCSV(result.missingRecords);
  const auditCSV = generateRunAuditCSV(auditRecord);
  const missingFilename = getMissingLoansFilename(result.runTimestamp);
  const auditFilename = getRunAuditFilename(result.runTimestamp);
  const missingSize = estimateFileSize(missingCSV);
  const auditSize = estimateFileSize(auditCSV);
  const handleDownloadMissing = () => {
    downloadCSV(missingCSV, missingFilename);
  };
  const handleDownloadAudit = () => {
    downloadCSV(auditCSV, auditFilename);
  };
  return <section aria-label="Download audit files" data-id="element-1">
      <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2">Audit Files</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3">
        <button type="button" onClick={handleDownloadMissing} className="group bg-white rounded-lg border border-gray-200 shadow-sm p-5 text-left hover:border-blue-300 hover:shadow-md transition-all focus:outline-none focus:ring-2 focus:ring-blue-300" aria-label={`Download ${missingFilename}`} data-id="element-4">
          <div className="flex items-start gap-4" data-id="element-5">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-blue-50 flex items-center justify-center group-hover:bg-blue-100 transition-colors" data-id="element-6">
              <FileTextIcon className="w-5 h-5 text-blue-600" aria-hidden="true" data-id="element-7" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-8">
              <p className="text-sm font-semibold text-gray-900" data-id="element-9">
                Missing Loans Report
              </p>
              <p className="text-xs text-gray-500 mt-1 truncate" data-id="element-10">
                {missingFilename}
              </p>
              <p className="text-xs text-gray-400 mt-0.5" data-id="element-11">
                {missingSize} · CSV
              </p>
            </div>
            <DownloadIcon className="w-5 h-5 text-gray-300 group-hover:text-blue-500 transition-colors flex-shrink-0 mt-1" aria-hidden="true" data-id="element-12" />
          </div>
        </button>

        <button type="button" onClick={handleDownloadAudit} className="group bg-white rounded-lg border border-gray-200 shadow-sm p-5 text-left hover:border-blue-300 hover:shadow-md transition-all focus:outline-none focus:ring-2 focus:ring-blue-300" aria-label={`Download ${auditFilename}`} data-id="element-13">
          <div className="flex items-start gap-4" data-id="element-14">
            <div className="flex-shrink-0 w-11 h-11 rounded-lg bg-purple-50 flex items-center justify-center group-hover:bg-purple-100 transition-colors" data-id="element-15">
              <FileTextIcon className="w-5 h-5 text-purple-600" aria-hidden="true" data-id="element-16" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-17">
              <p className="text-sm font-semibold text-gray-900" data-id="element-18">
                Run Audit Report
              </p>
              <p className="text-xs text-gray-500 mt-1 truncate" data-id="element-19">
                {auditFilename}
              </p>
              <p className="text-xs text-gray-400 mt-0.5" data-id="element-20">{auditSize} · CSV</p>
            </div>
            <DownloadIcon className="w-5 h-5 text-gray-300 group-hover:text-blue-500 transition-colors flex-shrink-0 mt-1" aria-hidden="true" data-id="element-21" />
          </div>
        </button>
      </div>
    </section>;
}